const zhCN = { 
  tabChangePassword: '修改密码',

  changePasswordTitle: '修改密码',
  passwordTxt: '密码',
  passwordBlank: '请输入 8-16 位密码，区分大小写！',
  
  passwordStrength: '密码强度',
  passwordLevel0: '低',
  passwordLevel1: '低',
  passwordLevel2: '中',
  passwordLevel3: '强',
  passwordTips: '请输入 8-16 位密码。请不要使用容易被猜到的密码。',
  passwordWarn: '密码强度不够！',

  repasswordTxt: '确认密码',
  repasswordBlank: '请确认密码！',
  repasswordWarn: '两次密码输入不一致！',

  bindPhoneTxt: '绑定手机号',

  changePWDBtn: '修改密码',

  changePasswordSuccess: '修改密码成功！',
  changePasswordSuccessBrief: '请牢记新密码，不要再搞忘了哟(＾Ｕ＾)ノ~ＹＯ！',
  changePasswordFail: '修改密码失败！',

  reloginTips: '后将重新登录'
}
const enUS = {
  tabChangePassword: 'Change Password',

  changePasswordTitle: 'Change Password',
  passwordTxt: 'Password',
  passwordBlank: 'Fill in 8-16 password, case sensitive!',
  
  passwordStrength: 'Strength',
  passwordLevel0: 'Low',
  passwordLevel1: 'Low',
  passwordLevel2: 'Medium',
  passwordLevel3: 'Advanced',
  passwordTips: 'Please enter 8-16 bit password. Don\'t use easily guessed passwords.',
  passwordWarn: 'Password strength not enough!',

  repasswordTxt: 'Confirm Password',
  repasswordBlank: 'Please confirm the password!',
  repasswordWarn: 'Two inconsistent password entries!',

  bindPhoneTxt: 'Phone',

  changePWDBtn: 'Change Password',

  changePasswordSuccess: 'Change the password successfully!',
  changePasswordSuccessBrief: 'Please remember the new password and don\'t forget it！',
  changePasswordFail: 'Change password failed!',

  reloginTips: 'ReLogin'
}

export default { zhCN, enUS }